/**
 * Accordion — panneau repliable animé (grid-template-rows), remplace <details>.
 * L'ouverture est contrôlable programmatiquement et n'écrase pas le flux.
 */
import { h, svgIcon } from "./dom.js";

const CHEVRON = svgIcon("m6 9 6 6 6-6");
// svgIcon() tags every icon `rail-icon`, which only the rail sizes. Without
// its own class the chevron had no size at all and grew to the accordion's
// full width, and `.accordion.open .accordion-chevron` never turned it.
CHEVRON.classList.add("accordion-chevron");

export interface AccordionHandle {
	element: HTMLElement;
	setOpen(open: boolean): void;
	isOpen(): boolean;
}

export function accordion(options: {
	title: string;
	children: HTMLElement[];
	/** Ouvert par défaut. Défaut : false. */
	open?: boolean;
	headerExtra?: HTMLElement;
}): AccordionHandle {
	let open = options.open ?? false;
	const bodyInner = h("div", { class: "accordion-body-inner" }, ...options.children);
	const body = h("div", { class: "accordion-body" }, bodyInner);
	const root = h("div", { class: open ? "accordion open" : "accordion" });
	const header = h(
		"button",
		{
			class: "accordion-header",
			type: "button",
			"aria-expanded": String(open),
			onclick: () => setOpen(!open),
		},
		h("span", null, options.title),
		options.headerExtra ?? null,
		CHEVRON.cloneNode(true)
	);
	root.append(header, body);

	function setOpen(next: boolean): void {
		open = next;
		root.classList.toggle("open", open);
		header.setAttribute("aria-expanded", String(open));
	}

	function isOpen(): boolean {
		return open;
	}

	return { element: root, setOpen, isOpen };
}
